import {Component} from '@angular/core';

@Component({
  selector: 'app-request-send',
  templateUrl: './request-send.component.html',
  styleUrls: ['./request-send.component.scss']
})
export class RequestSendComponent {

}
